import * as React from 'react';
import classnames from 'classnames';

const ResponsiveImage = ({ src , srcSet , alt , className , sizes , 'data-t': dataT ,  })=>/*#__PURE__*/ React.createElement("img", {
        "data-t": dataT || 'responsive-image',
        width: "100%",
        className: classnames('responsive-image', className),
        src: src,
        srcSet: srcSet,
        sizes: sizes,
        alt: alt
    })
;
var ResponsiveImage$1 = ResponsiveImage;

export { ResponsiveImage$1 as default };
//# sourceMappingURL=ResponsiveImage.js.map
